import { Text } from '@chakra-ui/react';
import { TipoDocumento, rotuloDocumento } from '../../utils/documento';

type DocumentoProps = {
	tipo: TipoDocumento;
	valor: string;
};

/**
 * O documento numa celula de tabela.
 *
 * So anota o tipo quando NAO e CPF: o caso comum da escola segue ocupando uma
 * linha so, como antes de a coluna existir, e o rotulo aparece exatamente onde
 * informa alguma coisa. Um numero de passaporte sem dizer que e passaporte
 * deixaria a lista ambigua - quem le nao tem como saber por que aquele cadastro
 * nao tem cara de CPF.
 */
export const Documento = ({ tipo, valor }: DocumentoProps) => (
	<>
		<Text>{valor}</Text>
		{tipo !== 'CPF' && (
			<Text fontSize="xs" color="gray.500">
				{rotuloDocumento(tipo)}
			</Text>
		)}
	</>
);
